const bip39 = async () => {
	const [lib, english] = await Promise.all([
		import('@scure/bip39'),
		import('@scure/bip39/wordlists/english')
	])
	return { lib, wordlist: english.wordlist }
}

/** BIP39 sentence form this wallet derives from. WASM does not do this itself. */
export function normalizeMnemonic(mnemonic: string): string {
	return mnemonic.trim().toLowerCase().normalize('NFKD').replace(/\s+/g, ' ')
}

export const validateMnemonic = async (mnemonic: string): Promise<string> => {
	const { lib, wordlist } = await bip39()
	const normalized = normalizeMnemonic(mnemonic)
	// bitcore threw on an invalid phrase and callers (restore-wallet-seed)
	// depend on that; @scure returns a boolean, so keep the throwing contract.
	if (!lib.validateMnemonic(normalized, wordlist)) {
		throw new Error('That phrase does not check out. Check each word and the order.')
	}
	return normalized
}
